import React from "react";
import { AdminDashboardWrapper } from "../../style/Admin/ManageDashboardStyle.jsx";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MainCarousel from "../../components/Banners/MainCarousel";
import BottomBanner from "../../components/Banners/BottomBanner";
import DashboardHeader from "../../components/Common/DashboardHeader.jsx";

const ManageDashboard = () => {
  return (
    <AdminDashboardWrapper>
      <DashboardHeader title="Manage Dashboard" />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      
      <MainCarousel
        editable={true}
        autoScroll={true}
        scrollInterval={3000}
        aspectRatio={16 / 5}
      />
    
      <BottomBanner
        editable={true}
        aspectRatio={16 / 6}
      />
    </AdminDashboardWrapper>
  );
};

export default ManageDashboard;


